<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">二维码考勤点</div>
        </div>
        <div class="inside_pages_right_content">
            <el-tabs type="border-card">
                <el-tab-pane label="值班门卫">
                    <form class="form-horizontal">
                        <div class="form-group options_box">
                            <label class="col-sm-2 control-label ">门卫人员</label>
                            <div class="col-sm-10">
                                <el-cascader  :options="departmentHead" v-model="selectedUserDataList" ref="patrolPersonnelSelect"  @change="selectPatrolPersonnel"  :props="{multiple: true, expandTrigger:'hover'}" clearable></el-cascader>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-offset-2 col-sm-10">
                                <el-button type="primary" size="mini">保存</el-button>
                            </div>
                        </div>
                    </form>
                </el-tab-pane>
                <el-tab-pane label="显示屏设置">
                    <form class="form-horizontal">
                        <div class="form-group options_box">
                            <label class="col-sm-2 control-label ">重要通知文本</label>
                            <div class="col-sm-10">
                                <el-input type="textarea" placeholder="请输入内容" v-model="requestData.test1" maxlength="30"  show-word-limit>
                                </el-input>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-offset-2 col-sm-10">
                                <el-button type="primary" size="mini">保存</el-button>
                            </div>
                        </div>
                    </form>
                </el-tab-pane>
                <el-tab-pane label="硬件配置面板">
                    <form class="form-horizontal">
                        <div class="form-group options_box">
                            <label class="col-sm-4 control-label ">
                                校鸽智能终端(中间件服务)
                            </label>
                            <div class="col-sm-8">
                                未开启
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-sm-4 control-label">
                                访客机
                            </label>
                            <div class="col-sm-8">
                                <el-radio-group v-model="deviceType"  size="mini">
                                    <el-radio-button value="0" label="0">未开启</el-radio-button>
                                    <el-radio-button value="1" label="1">开启</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">
                                人员布控
                            </label>
                            <div class="col-sm-8">
                                <el-radio-group v-model="deviceType"  size="mini">
                                    <el-radio-button value="0" label="0">未开启</el-radio-button>
                                    <el-radio-button value="1" label="1">开启</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">
                                百度人脸库
                            </label>
                            <div class="col-sm-8">
                                <el-radio-group v-model="deviceType"  size="mini">
                                    <el-radio-button value="0" label="0">未开启</el-radio-button>
                                    <el-radio-button value="1" label="1">开启</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-offset-2 col-sm-10">
                                <el-button type="primary" size="mini">保存</el-button>
                            </div>
                        </div>
                    </form>
                </el-tab-pane>
                <el-tab-pane label="功能流程管理">功能流程管理</el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            selectedPersonList:[],
            deviceType:0,
            // 请求参数
            requestData :{
                schoolId : this.$store.state.schoolId,
                pageNum : 1,
                pageSize : 20,
                text1:null,
                name2:null,
                status:null,
                
            },
            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                    {
                        id:123,
                        name1: '考勤点名称测试',
                        name2: '二维码编码测试',
                        name3: '5分钟',
                        date1: 1593273599,
                    }, 
                ],    
            },
            selectedUserDataList:[],
            // 部门负责人
            departmentHead:[],
            

        };
    },
    watch: {},
    computed: {},
    methods: {
        // 选择巡查人员(新增任务时使用)
        async selectPatrolPersonnel(data){
            // console.log(data)
            this.oneTaskData.timeQuantums = []
            var thisListData = {
                nameList:[],
                idList:[],
            }
            var selectedList = data
            var testData123 = []
            for(var selectedListKey in selectedList){
                var oneKey = selectedList[selectedListKey][0]
                var twoKey = selectedList[selectedListKey][1].split('-')[1]
               
                thisListData.nameList.push(this.departmentHead[oneKey].children[twoKey].label)
                thisListData.idList.push(this.departmentHead[oneKey].children[twoKey].thisId)
            }
            
            
            var formalData = {
                userNameArray:thisListData.nameList.join(','),
                userIdArray:thisListData.idList.join(','),
                completeTheWay:this.patrolPersonnel.completeTheWay,
                timeQuantumId:this.patrolPersonnel.timeQuantumId,

                // this.oneTaskData.timeQuantumList
            }
            
            this.oneTaskData.timeQuantums.push(formalData)
            this.oneTaskData.timeQuantumList.push(formalData)

            // console.log(this.oneTaskData.timeQuantums)
        },
        selectDepartmentHead(data){
            // console.log(this.testUserInfo)
            // console.log(data)
            var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
            // console.log(newData[0].data.thisId);
            this.oneTaskData.userId = newData[0].data.thisId
        },

        // 获取部门人员
        async getDepartmentHead(){
            var _this = this
            var paramData = {
                schoolId:this.$store.state.schoolId,
            }
            let res = await  this.$Http.getDepartmentHead(paramData,true)
			if(res.code == 200){
                for(var keyOne in res.data){
                    this.departmentHead.push({
                        value: keyOne,
                        label: res.data[keyOne].departmentName,
                        thisId: res.data[keyOne].departmentId,
                        thisLevel: 1,
                        children:[],

                    })
                    for(var keyTwo in res.data[keyOne].dlist){
                        // 负责人默认选择
                        // if(this.oneTaskData.userId == res.data[keyOne].dlist[keyTwo].userId){
                        //     this.testUserInfo.userId = []
                        //     this.testUserInfo.userId.push(keyOne)
                        //     this.testUserInfo.userId.push(keyOne + '-' + keyTwo)
                        // }
                        // 巡查人员默认选择
                        // for(var i = 0;this.selectedUserDataList.length>i;i++){
                        //     var selectedUserList = this.selectedUserDataList[i].userIdArray ? this.selectedUserDataList[i].userIdArray.split(',') : []
                        //     selectedUserList.forEach(element => {
                        //         if(element == res.data[keyOne].dlist[keyTwo].userId){
                        //             var personUserGroup = []
                        //             personUserGroup.push(keyOne)
                        //             personUserGroup.push(keyOne + '-' + keyTwo)
                        //             this.selectedUserDataList[i].userIdString.push(personUserGroup)

                        //         }
                        //     });
                        // }
                        this.departmentHead[keyOne].children.push({
                            value: keyOne + '-' + keyTwo,
                            label: res.data[keyOne].dlist[keyTwo].userName,
                            thisId: res.data[keyOne].dlist[keyTwo].userId,
                            thisLevel: 2,
                        })
                    }

                    

                }
                // this.departmentHead = departmentHeadList
                // console.log(this.departmentHead)
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },
      
        
    },
    created() {},
    mounted() {
        this.getDepartmentHead()
    }
};
</script>